module.exports = __webpack_public_path__ + "static/InputField_button-group-6aad94aad7109c251013cb0f38cf0d23.png";